import { domainNameIcpConfig } from '@/enum/domainNameIcp';
import { createStore } from 'vuex';

export default createStore({
  state: {
    searchVal: '',
    domainNameIcpConfig: domainNameIcpConfig.default
  },
  getters: {},
  mutations: {
    setSearchVal: (state, value) => {
      state.searchVal = value;
    },
    setSiteConfigVal: (state, value) => {
      state.domainNameIcpConfig = value;
    }
  },
  actions: {},
  modules: {}
});
